import { render, staticRenderFns } from "./ZjdfmxEdit.vue?vue&type=template&id=971ba514&scoped=true"
import script from "./ZjdfmxEdit.vue?vue&type=script&lang=js"
export * from "./ZjdfmxEdit.vue?vue&type=script&lang=js"
import style0 from "./ZjdfmxEdit.vue?vue&type=style&index=0&id=971ba514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971ba514",
  null
  
)

export default component.exports